module.exports = __webpack_public_path__ + "img/jobmule_colloquio.80866a67.png";